import { t } from "./i18n";

export const SECTION_GROUP_KEYS: Record<number, string> = {
  2: "activo",
  3: "registral",
  4: "registral",
  5: "fiscal",
  6: "urbanistico",
  7: "mercado",
  8: "contingencias",
  9: "entorno",
  10: "registral",
  11: "cierre",
  12: "cierre",
  13: "cierre",
};

/**
 * @param number the section's display number
 * @returns "Sección 6"
 */
export const sectionLabel = (number: number | string): string =>
  t("dueDiligence.finalReport.sectionLabel", { number });

/**
 * @param number the section number to look the group up by
 * @returns "Urbanístico", or undefined for a section with no group
 */
export const sectionGroupLabel = (number: number): string | undefined => {
  const groupKey = SECTION_GROUP_KEYS[number];
  return groupKey ? t(`dueDiligence.finalReport.sectionHeader.group.${groupKey}`) : undefined;
};

/**
 * @param number the section number, used both to print and to look up
 * @returns "Sección 6 · Urbanístico", or "Sección 1" when there is no group
 */
export const sectionFullLabel = (number: number): string => {
  const group = sectionGroupLabel(number);
  return group ? `${sectionLabel(number)} · ${group}` : sectionLabel(number);
};
